import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withKeys as _withKeys, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "n-data-table" }
const _hoisted_2 = {
  key: 0,
  class: "data-table__container"
}
const _hoisted_3 = { class: "loading-spinner-container" }
const _hoisted_4 = { class: "loading-spinner" }
const _hoisted_5 = {
  key: 1,
  class: "data-table__container"
}
const _hoisted_6 = { class: "n-table" }
const _hoisted_7 = { class: "column-heading" }
const _hoisted_8 = ["onClick", "onKeypress"]
const _hoisted_9 = {
  key: 1,
  class: "data-table__column"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "default-cell-display"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "actions-column"
}

import { PropType, ref, watch, onMounted, computed } from 'vue';
import NPagination, { Page } from './pagination.vue';
import DataTableColumn from './DataTableColumn';
import NLoadingSpinner from '../loading-spinner/loading-spinner.vue';
import PageData from './PageData';
import NIcon from '../../brand/icon/icon.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-data-table',
},
  __name: 'datatable',
  props: {
  columns: {
    type: Array as PropType<DataTableColumn[]>,
    required: true,
  },
  items: {
    type: Array as PropType<any[]>,
    required: true,
  },
  itemsTotal: {
    type: Number,
    default: 0,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  pagination: {
    type: Boolean,
    default: false,
  },
  itemsPerPage: {
    type: Number,
    default: 0,
  },
  sortBy: {
    type: String,
  },
  sortDesc: {
    type: Boolean,
    default: false,
  },
},
  emits: ["load", "cellClicked"],
  setup(__props, { emit: __emit }) {



const props = __props;

const emit = __emit;

const isLoading = ref(false);
const offset = ref(0);
const sortColumn = ref<string>();
const sortDirection = ref<'asc' | 'desc'>('asc');

watch(
  () => props.loading,
  (loading: boolean) => (isLoading.value = loading),
  { immediate: true },
);

watch(
  () => props.items,
  () => (isLoading.value = false),
  { immediate: true },
);

onMounted(() => {
  sortColumn.value = props.sortBy;
  sortDirection.value = props.sortDesc ? 'desc' : 'asc';
});

async function onPageChanged(page: Page) {
  offset.value = page.start;
  await loadData();
}

function loadData() {
  isLoading.value = true;
  emit('load', {
    offset: offset.value,
    sortColumn: sortColumn.value,
    sortDirection: sortDirection.value,
  } as PageData);
}

function getSortClass(column: string) {
  if (column !== sortColumn.value) {
    return '';
  }
  return sortDirection.value;
}

function handleColumnClick(column: string) {
  if (column === sortColumn.value) {
    if (sortDirection.value === 'desc') {
      sortDirection.value = 'asc';
    } else if (sortDirection.value === 'asc') {
      sortDirection.value = 'desc';
    }
  } else {
    sortDirection.value = 'desc';
    sortColumn.value = column;
  }
  loadData();
}

function isCellClickable(row: any, clickableConfig?: boolean | ((row: any) => boolean)): boolean {
  if (typeof clickableConfig === 'function') {
    return clickableConfig(row);
  }
  return !!clickableConfig;
}

function cellClicked(row: any) {
  emit('cellClicked', row);
}

const hasResults = computed(() => {
  if (props.pagination) {
    return props.itemsTotal > 0 && props.items && props.items.length > 0;
  }
  return props.items && props.items.length > 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(NLoadingSpinner, { "no-margin": "" })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (hasResults.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: column.name,
                    class: _normalizeClass({ 'th--with-icon': column.icon })
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      (column.sortable)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["data-table__column", { sortable: column.sortable }])
                          }, [
                            (column.sortable)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  role: "button",
                                  class: "column__sort-trigger",
                                  tabindex: "0",
                                  onClick: ($event: any) => (handleColumnClick(column.name)),
                                  onKeypress: [
                                    _withKeys(($event: any) => (handleColumnClick(column.name)), ["enter"]),
                                    _withKeys(($event: any) => (handleColumnClick(column.name)), ["space"])
                                  ]
                                }, [
                                  (column.icon)
                                    ? (_openBlock(), _createBlock(NIcon, {
                                        key: 0,
                                        icon: column.icon
                                      }, null, 8, ["icon"]))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(column.display) + " ", 1),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(getSortClass(column.name))
                                  }, null, 2)
                                ], 40, _hoisted_8))
                              : _createCommentVNode("", true)
                          ], 2))
                        : _createCommentVNode("", true),
                      (!column.sortable)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            (column.icon)
                              ? (_openBlock(), _createBlock(NIcon, {
                                  key: 0,
                                  icon: column.icon
                                }, null, 8, ["icon"]))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(column.display), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128)),
                (_ctx.$slots.actions)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_10))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (row) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "data-item",
                  key: row.id
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column) => {
                    return (_openBlock(), _createElementBlock("td", {
                      class: _normalizeClass(["data-cell", { 'cell-wrap': column.wrappable }]),
                      key: column.name
                    }, [
                      (!_ctx.$slots[column.name] && !column.formatter)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (isCellClickable(row, column.clickable))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "clickable-cell",
                                  onClick: ($event: any) => (cellClicked(row))
                                }, _toDisplayString(row[column.name]), 9, _hoisted_12))
                              : _createCommentVNode("", true),
                            (!isCellClickable(row, column.clickable))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(row[column.name]), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (!_ctx.$slots[column.name] && column.formatter)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              (isCellClickable(row, column.clickable))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "clickable-cell",
                                    onClick: ($event: any) => (cellClicked(row))
                                  }, _toDisplayString(column.formatter(row[column.name])), 9, _hoisted_15))
                                : _createCommentVNode("", true),
                              (!isCellClickable(row, column.clickable))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(column.formatter(row[column.name])), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _renderSlot(_ctx.$slots, column.name, {
                              key: 2,
                              row: row
                            })
                    ], 2))
                  }), 128)),
                  (_ctx.$slots.actions)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                        _renderSlot(_ctx.$slots, "actions", { row: row })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.pagination && hasResults.value)
      ? (_openBlock(), _createBlock(NPagination, {
          key: 2,
          onPageChanged: onPageChanged,
          itemsTotal: __props.itemsTotal,
          itemsPerPage: __props.itemsPerPage
        }, null, 8, ["itemsTotal", "itemsPerPage"]))
      : _createCommentVNode("", true),
    (!hasResults.value && !isLoading.value)
      ? _renderSlot(_ctx.$slots, "nodata", { key: 3 })
      : _createCommentVNode("", true)
  ]))
}
}

})